import { render, staticRenderFns } from "./zhixuanhuanji.vue?vue&type=template&id=d3984d22&scoped=true&"
import script from "./zhixuanhuanji.vue?vue&type=script&lang=js&"
export * from "./zhixuanhuanji.vue?vue&type=script&lang=js&"
import style0 from "./zhixuanhuanji.vue?vue&type=style&index=0&id=d3984d22&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3984d22",
  null
  
)

export default component.exports